// Chargement différé des scripts tiers non critiques (MTCaptcha, gtag).
// But : libérer le main thread au boot pour améliorer INP / TBT sur mobile.
// Les scripts se chargent au premier signe d'interaction utilisateur
// (touch/click/scroll/keydown/mousemove) OU après un délai d'idle en fallback.

const loaded = new Set<string>();
let armed = false;

function injectScript(src: string, attrs: Record<string, string> = {}): Promise<void> {
  if (loaded.has(src)) return Promise.resolve();
  loaded.add(src);
  return new Promise((resolve) => {
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.defer = true;
    Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
    s.onload = () => resolve();
    s.onerror = () => resolve();
    document.head.appendChild(s);
  });
}

/** Charge MTCaptcha à la demande (idempotent). */
export function loadMTCaptcha(): Promise<void> {
  return injectScript('https://service.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js');
}

/** Charge gtag Google Ads et configure la mesure. */
async function loadGtag() {
  const GA_ID = 'AW-17533345338';
  (window as any).dataLayer = (window as any).dataLayer || [];
  function gtag(...args: any[]) {
    (window as any).dataLayer.push(args);
  }
  (window as any).gtag = gtag;
  await injectScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`);
  gtag('js', new Date());
  gtag('config', GA_ID, { send_page_view: true });
}

function triggerDeferredLoad() {
  if (armed) return;
  armed = true;
  // Décomposition en tâches courtes pour ne pas bloquer l'interaction en cours
  const idle = (window as any).requestIdleCallback || ((cb: any) => setTimeout(cb, 200));
  idle(() => loadMTCaptcha());
  idle(() => loadGtag());
}

/** À appeler une seule fois depuis main.tsx. */
export function initDeferredScripts() {
  if (typeof window === 'undefined') return;

  const events: Array<keyof WindowEventMap> = [
    'pointerdown', 'touchstart', 'keydown', 'scroll', 'mousemove'
  ];
  const opts: AddEventListenerOptions = { once: true, passive: true, capture: true };
  const handler = () => {
    triggerDeferredLoad();
    events.forEach((e) => window.removeEventListener(e, handler, true));
  };
  events.forEach((e) => window.addEventListener(e, handler, opts));

  // Fallback : si pas d'interaction, charger après 4s d'idle
  const idle = (window as any).requestIdleCallback || ((cb: any) => setTimeout(cb, 4000));
  idle(() => triggerDeferredLoad(), { timeout: 5000 });
}
